import { render, staticRenderFns } from "./quanLyVanBanDi.vue?vue&type=template&id=bf9bd316&"
import script from "./quanLyVanBanDi.vue?vue&type=script&lang=js&"
export * from "./quanLyVanBanDi.vue?vue&type=script&lang=js&"
import style0 from "./quanLyVanBanDi.vue?vue&type=style&index=0&lang=css&"
import style1 from "./quanLyVanBanDi.vue?vue&type=style&index=1&lang=css&"
import style2 from "./quanLyVanBanDi.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports